export default __webpack_public_path__ + "static/media/7SJ64.603e4fdf.jpg";